import type { TypeShop } from '@/app/types/editor/shop';
import store from '@/app/store/store';

/**
 * anonymous function
 * @returns string
 */
export default (): string => {
  const shop = store.getValue('__shop');
  const domain = (shop as TypeShop)?.shopifyDomain;
  if (domain) {
    return domain;
  }
  return '';
};
